import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterPagoPremio from 'views/machine/pagopremio/filterPagoPremio'; // Importing FilterPagoPremio component
import PagoPremio from 'views/machine/pagopremio/PagoPremio'; // Importing PagoPremio component
import TablePagoPremio from 'views/machine/pagopremio/tablePagoPremio'; // Importing TablePagoPremio component
import DetailsPagoPremio from 'views/machine/pagopremio/detailsPagoPremio'; // Importing DetailsPagoPremio component
import RecordPagoPremio from 'views/machine/pagopremio/recordPagoPremio'; // Importing RecordPagoPremio component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for Pago Premio.
 * @extends JetView
 */
export default class pagoPremioView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Right section configuration with details and record components
        const right = {
            type: 'wide',
            rows: [DetailsPagoPremio, RecordPagoPremio],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left section configuration with toolbar and various components
        const left = {
            Width: 250,
            responsiveCell: false,
            height: 1500,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Pago Premio') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigation on click
                                },
                            ],
                        },
                    ],
                },
                FilterPagoPremio, // Filter component
                PagoPremio, // Main PagoPremio component
                TablePagoPremio, // Table component for displaying data
                toolbar, // Pagination toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide',
            responsive: true,
            css: 'out', // CSS class for styling
            cols: [
                left, // Left section
                { view: 'resizer' }, // Resizer between left and right sections
            ],
        };
    }
}

// FILE DOCUMENTED
